interface ICheckAfgEligibilityParams {
  balloonMaxOdometers: Record<string, number>;
  odometer: number | null | undefined;
  vehicleYear: string | number | null | undefined;
}

export const checkAfgEligibility = ({
  balloonMaxOdometers,
  odometer,
  vehicleYear,
}: ICheckAfgEligibilityParams): boolean => {
  if (vehicleYear == null || odometer == null) {
    return false;
  }

  const maxAvailableMileage = balloonMaxOdometers[String(vehicleYear)];

  if (maxAvailableMileage == null) {
    return false;
  }

  return odometer <= maxAvailableMileage;
};
